let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

//eye patch button restrictions
// Capped variant/product IDs
// const exists = !!document.querySelector('.eye-patch-8200966963365');
// if (exists) {
const cappedVariantId = 42388327399589;
const cappedProductId = 8200966963365;
let isProcessing = false;

// Wait for DOM to load
document.addEventListener("DOMContentLoaded", function () {
   const exists = !!document.querySelector('.eye-patch-8200966963365');
    if (exists) {
  document.querySelectorAll(".devx_eye_patch").forEach(function (element) {
    element.addEventListener("click", function (e) {
      e.preventDefault();

      const variantInput = this.querySelector(".dev_home_getvariantid");
      const button = this.querySelector("button");
      const variantId = variantInput ? variantInput.value : null;

      if (!variantId || isProcessing) return;

      isProcessing = true;
      button.disabled = true;

      if (variantId == cappedVariantId) {
        fetch("/cart.js")
          .then((res) => res.json())
          .then((cart) => {
            const productInCart = cart.items.some(
              (item) => item.variant_id == cappedVariantId
            );

            if (productInCart) {
              document.querySelector(".popup-overlay").style.display = "block";
              isProcessing = false;
              button.disabled = false;
            } else {
              addProductToCart(variantId, 1, button);
            }
          })
          .catch(() => {
            isProcessing = false;
            button.disabled = false;
          });
      } else {
        addProductToCart(variantId, 1, button);
      }
    });
  });
}
});

// const cappedVariantId = 42388327399589;
// const cappedProductId = 8200966963365;
// let isProcessing = false;

// // Wait for DOM to load
// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".devx_eye_patch").forEach(function (element) {
//     element.addEventListener("click", function (e) {
//       e.preventDefault();

//       const variantInput = this.querySelector(".dev_home_getvariantid");
//       const button = this.querySelector("button");
//       const variantId = variantInput ? variantInput.value : null;

//       if (!variantId || isProcessing) return;

//       isProcessing = true;
//       button.disabled = true;

//       if (variantId == cappedVariantId) {
//         fetch("/cart.js")
//           .then((res) => res.json())
//           .then((cart) => {
//             const productInCart = cart.items.some(
//               (item) => item.variant_id == cappedVariantId
//             );

//             if (productInCart) {
//               document.querySelector(".popup-overlay").style.display = "block";
//               isProcessing = false;
//               button.disabled = false;
//             } else {
//               addProductToCart(variantId, 1, button);
//             }
//           })
//           .catch(() => {
//             isProcessing = false;
//             button.disabled = false;
//           });
//       } else {
//         addProductToCart(variantId, 1, button);
//       }
//     });
//   });
// });

function addProductToCart(variantId, quantity = 1, button) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: `id=${variantId}&quantity=${quantity}`,
  })
    .then((res) => res.json())
    .then(() => {
      updateCartDrawer();
    })
    .catch((err) => console.error("Error:", err))
    .finally(() => {
      isProcessing = false;
      button.disabled = false;
    });
}

function updateCartDrawer() {
  fetch(`/?section_id=${window.section2}`)
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
      return res.text();
    })
    .then((html) => {
      document.getElementById(`shopify-section-${window.section2}`).innerHTML = html;
      document.querySelector("cart-drawer#cart-drawer-unique")?.classList.add("active");
      console.log("Cart section reloaded successfully.");
      updateCartIconBubble();
    });
}

function updateCartIconBubble() {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const totalItems = cart.item_count;
      const icon = document.querySelector(".dev_desktop_cart_icon");
      if (icon) {
        const bubble = document.createElement("div");
        bubble.className = "cart-count-bubble";
        bubble.innerHTML = `
          <span aria-hidden="true">${totalItems}</span>
          <span class="visually-hidden">${totalItems} items</span>
        `;
        icon.appendChild(bubble);
      }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    // Check if the cart drawer should be opened
    const openCart = localStorage.getItem('openCartDrawer');

    if (openCart === 'true') {
        const cartDrawer = document.querySelector("cart-drawer#cart-drawer-unique");

        if (cartDrawer) {
            // Add the active class
            cartDrawer.classList.add("active");

            // Trigger any related UI events
            if (typeof $ !== 'undefined') {
                $("cart-drawer#cart-drawer-unique").trigger("open.drawer");
            }

            // Dispatch a custom event if needed
            const openEvent = new Event("drawer:open");
            cartDrawer.dispatchEvent(openEvent);
        } else {
            console.error("Cart drawer element not found.");
        }

        // Clear the flag from localStorage to prevent repeated opening
        localStorage.removeItem('openCartDrawer');
    }
});
  
document.addEventListener('click', function(e) {
  if (e.target && e.target.classList.contains('devx_add_to_cart_button')) {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon) {
      cartIcon.click();
    }
  }
});

document.addEventListener("click", function (event) {
  if (
    event.target.id === "cart-icon-bubble" &&
    event.target.classList.contains("header__icon")
  ) {
    const cartDrawer = document.querySelector("cart-drawer#cart-drawer-unique");
    if (cartDrawer) {
      cartDrawer.classList.add("active");
    }
  }
});







